import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';
import { AnonymousTokenNotAllowedError } from '../../errors/AnonymousTokenNotAllowedError';

class CustomerApiService extends Api {
  async addCustomerAsApiCustomer() {
    try {
      const { data } = await this.httpClient.patch('/customer/api-user-access?action=enable');
      return data;
    } catch (error) {
      if (!(error instanceof AnonymousTokenNotAllowedError)) {
        ErrorManagement.exception({
          exception: error,
          tags: {
            fileLocation: 'CustomerApiService',
            featureFunction: 'addCustomerAsApiCustomer',
          },
          fingerprint: ['customer-api-service-add-customer-as-api-customer'],
        });
      }
      throw error;
    }
  }
}

export default CustomerApiService;
